import { Options, Option } from './useOptions.types';
import { useState } from 'react';
import { getOptionFromValue } from './useOptions.utils';

export const useOptions = <T = string,>(
  options: Options<T>,
  defaultOption?: Option<T> | string,
  withIsSelected = false,
) => {
  if (!options) {
    console.error('You must provide an array of Options');
  }

  const [optionSelected, setSelectedOption] = useState<Option<T> | undefined>(
    typeof defaultOption === 'string'
      ? getOptionFromValue(options, defaultOption)
      : defaultOption,
  );

  const onOptionChange = (value: string) => {
    const selectedIndex = getOptionFromValue(options, value);
    selectedIndex && setSelectedOption(selectedIndex);
  };

  return {
    options:
      withIsSelected && optionSelected
        ? options.map((option) => ({
            ...option,
            isSelected: optionSelected.value === option.value,
          }))
        : options,
    optionSelected,
    optionsLength: options.length,
    onOptionChange,
  };
};

export default useOptions;
